// @flow

import React from 'react'
import styled from 'styled-components'
import { compose, withProps } from 'recompose'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps'

import theme from '../../../tailwind'

// Anything falsy (i.e. undefined, null, '', etc.) will short circuit to the default value
const GOOGLE_MAPS_API_KEY = process.env.GATSBY_GOOGLE_MAPS_API_KEY || ''

const defaultLocation = { lat: 26.458012, lng: -81.963475 }
const googleMapsLoadingColor: string = '#e5e3df'

const StyledContainer = styled.div`
  height: 12rem;
  background-color: ${googleMapsLoadingColor};

  @media screen and (min-with: ${theme.screens.md}) {
    height: 16rem;
  }

  @media screen and (min-width: ${theme.screens.lg}) {
    height: 26rem;
  }
`

type LocationMapProps = {
  isMarkerShown?: boolean,
  location?: { lat: number, lng: number },
}

const LocationMap: any = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <StyledContainer />,
    containerElement: <StyledContainer />,
    mapElement: <div className="h-full" />,
  }),
  withScriptjs,
  withGoogleMap,
)(({ isMarkerShown, location }: LocationMapProps) => (
  <GoogleMap defaultZoom={15} defaultCenter={location || defaultLocation}>
    {isMarkerShown && <Marker position={location || defaultLocation} />}
  </GoogleMap>
))

export default LocationMap
